import { useAlert } from '@register-ui/utils';
import { AlertModal } from './alert-modal';

export function AlertProvider() {
    const { props, hideModal } = useAlert();

    if (!props) return null;

    return <AlertModal open {...props} onClose={hideModal} />;
}
